import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution, track } from "@/lib/analytics";

// Runs on every route navigation: scrolls to the top, captures first-touch sponsor
// attribution from the URL, and fires a fire-and-forget "visit" analytics event.
export function ScrollToTop() {
  const { pathname, key } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    captureAttribution();
    track("visit", { path: pathname });
  }, [pathname, key]);
  return null;
}
